module.exports = __webpack_public_path__ + "static/media/interactive-link.f81b2968.svg";